import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Actions\Answers\SubmitAnswer::__invoke
* @see app/Actions/Answers/SubmitAnswer.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}/answers'
*/
export const store = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/cases/{year}/{month}/{day}/{sqid}/answers',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Answers\SubmitAnswer::__invoke
* @see app/Actions/Answers/SubmitAnswer.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}/answers'
*/
store.url = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            year: args[0],
            month: args[1],
            day: args[2],
            sqid: args[3],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        year: args.year,
        month: args.month,
        day: args.day,
        sqid: args.sqid,
    }

    return store.definition.url
            .replace('{year}', parsedArgs.year.toString())
            .replace('{month}', parsedArgs.month.toString())
            .replace('{day}', parsedArgs.day.toString())
            .replace('{sqid}', parsedArgs.sqid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Answers\SubmitAnswer::__invoke
* @see app/Actions/Answers/SubmitAnswer.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}/answers'
*/
store.post = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

const answers = {
    store: Object.assign(store, store),
}

export default answers